import { LogLevel } from '@azure/msal-browser';
function getRedirectUri() {
    const env = (process.env.APP_ENV || 'prod').toLowerCase();
    // `local` uses the live browser origin so the redirect always matches
    // whatever host:port the dev server is on (e.g. https://localhost:3000).
    // The matching reply URL must be registered on the Azure AD app.
    if (env === 'local')
        return `${window.location.origin}/home`;
    if (env === 'dev')
        return 'https://dev-validaite.deloitte.com/home';
    if (env === 'stage' || env === 'staging')
        return 'https://stage-validaite.deloitte.com/home';
    return 'https://validaite.deloitte.com/home';
}
export const msalConfig = {
    auth: {
        clientId: '105a3b9d-c856-441d-b725-7b975ac898ee',
        authority: 'https://login.microsoftonline.com/36da45f1-dd2c-4d1f-af13-5abe46b99921',
        redirectUri: getRedirectUri(),
        postLogoutRedirectUri: '/login',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};
export const loginRequest = {
    // Use User.Read (delegated) instead of User.Read.All (requires admin consent)
    scopes: ['User.Read'],
};
